import {TextareaHTMLAttributes, forwardRef, useId} from 'react';
import clsx from 'clsx';
import {ErrorType} from 'utils/types';
import styles from './styles.module.css';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  invalid?: boolean;
  error?: ErrorType;
  maxLength?: number;
};

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({className, label, disabled, name, invalid, placeholder, ...textareaProps}, ref) => {
    const inputId = useId();

    return (
      <div className={clsx(styles.container, className)}>
        <textarea
          ref={ref}
          id={inputId}
          name={name}
          disabled={disabled}
          className={clsx(styles.textarea, {
            [styles.textareaError]: invalid,
            [styles.textareaDisabled]: disabled,
          })}
          {...textareaProps}
          placeholder={placeholder}
        />
        {label && (
          <label
            htmlFor={inputId}
            className={clsx(styles.label, {
              [styles.labelError]: invalid,
              [styles.labelDisabled]: disabled,
            })}
          >
            {label}
          </label>
        )}
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';

export {Textarea};
